import { ClientComponent } from "./ClientComponent";
import { ServerComponent } from "./ServerComponent";
import {
  type StoryblokComponentProps,
  type StoryblokComponentsProps,
} from "./types";

export const StoryblokComponent = ({
  blok,
  preview,
  ...rest
}: StoryblokComponentProps) => {
  if (typeof preview === "undefined") {
    throw new Error(
      "Preview was not passed down as a prop to StoryblokComponent, this will cause a fetch overflow",
      {
        cause: blok.component,
      }
    );
  }

  if (!blok) {
    const errorMessage = "Please provide a blok";
    console.error(errorMessage);
    return <div>{errorMessage}</div>;
  }

  if (!blok.component) {
    const errorMessage = `Component is not listed in bloks`;
    console.error(errorMessage);
    return <div>{errorMessage}</div>;
  }

  if (preview) {
    return <ClientComponent {...rest} blok={blok} preview />;
  }

  return <ServerComponent {...rest} preview={false} blok={blok} />;
};

export const StoryblokComponentList = ({
  bloks,
  preview,
  ...rest
}: StoryblokComponentsProps) => {
  return (
    <>
      {bloks.map((blok) => (
        <StoryblokComponent
          key={blok._uid}
          blok={blok}
          preview={preview}
          {...rest}
        />
      ))}
    </>
  );
};
